// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"8f5847ddb77a28312b4c","873":"553f6696696f750197ff"}[chunkId] + ".js";
};